import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Heading } from '@/components/ui/shared/heading';
import React from 'react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { useCartData } from '../../CartPage/context/CartDataContext';

export default function SuccessStepComplex() {
  const { complex } = useCartData();
  return (
    <div className="flex flex-col sm:flex-row sm:gap-4">
      <div className="sm:w-3/3">
        {!complex && (
          <Card>
            <CardHeader>
              <Heading variant="2">
                Dėkojame! Jūsų mokėjimas už paslaugų paketą gautas.
              </Heading>
            </CardHeader>
            <CardContent>
              Registracija įsigytai paslaugai vykdoma telefonu: 1811.
              <br></br>
              Įsigytus paslaugų paketus ir detalesnę informaciją apie juos
              galite peržiūrėti prisijungę prie{' '}
              <strong>paciento paskyros.</strong>
            </CardContent>
            <CardFooter></CardFooter>
          </Card>
        )}

        {complex?.simpleWorkflow && (
          <Card>
            <CardHeader>
              <Heading variant="2">
                Dėkojame! Jūsų užklausa sėkmingai pateikta.
              </Heading>
            </CardHeader>
            <CardContent>
              Mūsų komanda susisieks su Jumis per artimiausias 24 valandas
              (išskyrus savaitgalio ar šventines dienas). Nesulaukus skambučio,
              prašome mus apie tai informuoti tel. 1811 arba el. paštu
              pacientams@affidea.com
            </CardContent>
            <CardFooter></CardFooter>
          </Card>
        )}
      </div>
      {/* 
      <div className="sm:w-1/3 mt-2 sm:mt-0">
        <div className="flex flex-col gap-4">
          <SpecialistInfoCard />
          <Card>
            <CardHeader>
              <Heading variant="3">Apmokėjimo informacija</Heading>
            </CardHeader>

            <CardContent>
              <div className="flex items-center justify-between">
                <div className="text-black">Pirminė konsultacija</div>
                <div className="text-primary font-bold">45 €</div>
              </div>
              <Separator className={'my-2'} />
              <div className="flex items-center justify-between">
                <div className="text-black">Nuolaidos kodas</div>
                <div className="text-primary font-bold">-10 €</div>
              </div>
              <Separator className={'my-2'} />
            </CardContent>

            <CardFooter className="p-0 px-2 sm:px-4 text-xl py-4">
              <div className="w-full space-y-1">
                <div className="flex w-full items-center justify-between">
                  <div className="text-black">Iš viso su pvm</div>
                  <div className="text-primary font-bold">45 €</div>
                </div>
                <Label variant="subheading">
                  Atsiskaitymo būdas: Mokėjimas atvykus į padalinį.{' '}
                </Label>
              </div>
            </CardFooter>
          </Card>
        </div>
      </div> */}
    </div>
  );
}
